import {
    // Badge, Button, Descriptions,
    Divider,
    // message, Modal,
    Tabs,
} from 'antd'
import React from 'react'
import { SessionRevisor } from '../../types/session'
import RevisorUserSettings from './RevisorUserSettings'
import './style.less'
// import { DollarOutlined } from '@ant-design/icons'
// import { add, format, isAfter, toDate } from 'date-fns'
// import { httpPostRevisor } from '../../services/http'
// import { loadStripe } from '@stripe/stripe-js'
// import { CustomerPortal } from '../../lib/interfaces'

const { TabPane } = Tabs

// const api_key = process.env.GATSBY_STRIPE_PUBLIC_KEY || ''

export default function RevisorSettings({ session }: { session: SessionRevisor }) {
    // const [MBLoading, setMBLoading] = useState(false)

    // function sessionIsActiveAdvisor() {
    //     return (
    //         session.user.has_paid &&
    //         session.user.is_advisor &&
    //         session.user.current_advisor_period_end &&
    //         isAfter(
    //             toDate(new Date(session.user.current_advisor_period_end)),
    //             add(toDate(new Date()), { days: 2 })
    //         )
    //     )
    // }

    // const manageBilling = async () => {
    //     setMBLoading(true)
    //     try {
    //         const res = await httpPostRevisor<CustomerPortal>(
    //             '/auth-revisor/subscription-customer-portal'
    //         )
    //         if (!res.data) return
    //         if (res.data.url) {
    //             window.location.href = res.data.url
    //         } else if (res.data.sessionId) {
    //             const sessId = res.data.sessionId
    //             const stripe = await loadStripe(api_key)
    //             const stripeRes = await stripe?.redirectToCheckout({
    //                 sessionId: sessId,
    //             })
    //             Modal.error({
    //                 title: 'Could not complete checkout',
    //                 content: stripeRes?.error.message,
    //             })
    //         }
    //     } catch (error) {
    //         message.error('Something went wrong: ' + error.toString(), 5)
    //     } finally {
    //         setMBLoading(false)
    //     }
    // }

    return (
        <div
            style={{
                width: '90%',
                margin: 'auto',
                marginTop: 20,
                marginBottom: 20,
            }}
        >
            <h1>Settings</h1>
            <Divider />
            <Tabs defaultActiveKey="1">
                <TabPane tab="Personal" key="Personal">
                    <div className="revisor-overview-grid">
                        <RevisorUserSettings session={session} />
                    </div>
                </TabPane>
                {/* <TabPane tab="Subscription" key="Subscription">
                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="Status" span={3}>
                            {sessionIsActiveAdvisor() ? (
                                <Badge status="processing" text="Active" color="#7EAC55" />
                            ) : (
                                <Badge text="Inactive" color="#f5222d" />
                            )}
                        </Descriptions.Item>
                        <Descriptions.Item label="Subscription reset" span={3}>
                            {session.user.is_advisor && session.user.current_advisor_period_end
                                ? formatText(
                                    toDate(new Date(session.user.current_advisor_period_end)),
                                    layoutDictKeyFormat
                                )
                                : 'No subscription'}
                        </Descriptions.Item>
                    </Descriptions>
                    <Button
                        icon={<DollarOutlined />}
                        type="primary"
                        onClick={manageBilling}
                        loading={MBLoading}
                    >
                        Manage billing
                    </Button>
                </TabPane> */}
            </Tabs>
        </div>
    )
}
